/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type OutputTokensDetails = {
  reasoningTokens: number;
};

/** @internal */
export const OutputTokensDetails$inboundSchema: z.ZodType<
  OutputTokensDetails,
  z.ZodTypeDef,
  unknown
> = z.object({
  reasoning_tokens: z.number().int(),
}).transform((v) => {
  return remap$(v, {
    "reasoning_tokens": "reasoningTokens",
  });
});
/** @internal */
export type OutputTokensDetails$Outbound = {
  reasoning_tokens: number;
};

/** @internal */
export const OutputTokensDetails$outboundSchema: z.ZodType<
  OutputTokensDetails$Outbound,
  z.ZodTypeDef,
  OutputTokensDetails
> = z.object({
  reasoningTokens: z.number().int(),
}).transform((v) => {
  return remap$(v, {
    reasoningTokens: "reasoning_tokens",
  });
});

export function outputTokensDetailsToJSON(
  outputTokensDetails: OutputTokensDetails,
): string {
  return JSON.stringify(
    OutputTokensDetails$outboundSchema.parse(outputTokensDetails),
  );
}
export function outputTokensDetailsFromJSON(
  jsonString: string,
): SafeParseResult<OutputTokensDetails, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => OutputTokensDetails$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'OutputTokensDetails' from JSON`,
  );
}
